import { Action, createReducer, on } from '@ngrx/store';
import {
  closeSubmissionPeriod,
  closeSubmissionPeriodFailure,
  closeSubmissionPeriodSuccess,
  createKeyDate,
  createKeyDateFailure,
  createKeyDateSuccess,
  createReportingPeriod,
  createReportingPeriodFailure,
  createReportingPeriodSuccess,
  deleteKeyDate,
  deleteKeyDateFailure,
  deleteKeyDateSuccess,
  deleteReportingPeriod,
  deleteReportingPeriodFailure,
  deleteReportingPeriodSuccess,
  forceGrantSubmission,
  forceGrantSubmissionFailure,
  forceGrantSubmissionSuccess,
  generateDashboardData,
  generateDashboardDataFailure,
  generateDashboardDataSuccess,
  getDashboards,
  getDashboardsFailure,
  getDashboardsSuccess,
  getKeyDates,
  getKeyDatesFailure,
  getKeyDatesSuccess,
  getOverviewReport,
  getOverviewReportFailure,
  getOverviewReportSuccess,
  getRemovedUserReport,
  getRemovedUserReportFailure,
  getRemovedUserReportSuccess,
  getReportingPeriods,
  getReportingPeriodsFailure,
  getReportingPeriodsSuccess,
  updateDashboard,
  updateDashboardFailure,
  updateDashboardSuccess,
  updateKeyDate,
  updateKeyDateFailure,
  updateKeyDateSuccess,
  updateReportingPeriod,
  updateReportingPeriodFailure,
  updateReportingPeriodSuccess,
} from './actions';
import { initialState, State } from './state';

export const settingsFeatureKey = 'settings';

const settingsReducer = createReducer(
  initialState,
  on(closeSubmissionPeriod, (state) => ({
    ...state,
    closeSubmissionPeriodLoading: true,
  })),
  on(closeSubmissionPeriodFailure, (state, { error, message }) => ({
    ...state,
    closeSubmissionPeriodError: { error, message },
    closeSubmissionPeriodLoading: false,
  })),
  on(closeSubmissionPeriodSuccess, (state) => ({
    ...state,
    closeSubmissionPeriodLoading: false,
  })),
  on(createKeyDate, (state) => ({
    ...state,
    createKeyDateLoading: true,
  })),
  on(createKeyDateFailure, (state, { error, message }) => ({
    ...state,
    createKeyDateError: { error, message },
    createKeyDateLoading: false,
  })),
  on(createKeyDateSuccess, (state) => ({
    ...state,
    createKeyDateLoading: false,
  })),

  on(createReportingPeriod, (state) => ({
    ...state,
    createReportingPeriodLoading: true,
  })),
  on(createReportingPeriodFailure, (state, { error, message }) => ({
    ...state,
    createReportingPeriodError: { error, message },
    createReportingPeriodLoading: false,
  })),
  on(createReportingPeriodSuccess, (state) => ({
    ...state,
    createReportingPeriodLoading: false,
  })),

  on(deleteKeyDate, (state) => ({
    ...state,
    deleteKeyDateLoading: true,
  })),
  on(deleteKeyDateFailure, (state, { error, message }) => ({
    ...state,
    deleteKeyDateError: { error, message },
    deleteKeyDateLoading: false,
  })),
  on(deleteKeyDateSuccess, (state) => ({
    ...state,
    deleteKeyDateLoading: false,
  })),

  on(deleteReportingPeriod, (state) => ({
    ...state,
    deleteReportingPeriodLoading: true,
  })),
  on(deleteReportingPeriodFailure, (state, { error, message }) => ({
    ...state,
    deleteReportingPeriodError: { error, message },
    deleteReportingPeriodLoading: false,
  })),
  on(deleteReportingPeriodSuccess, (state) => ({
    ...state,
    deleteReportingPeriodLoading: false,
  })),

  on(forceGrantSubmission, (state) => ({
    ...state,
    forceGrantSubmissionLoading: true,
  })),
  on(forceGrantSubmissionFailure, (state, { error, message }) => ({
    ...state,
    forceGrantSubmissionError: { error, message },
    forceGrantSubmissionLoading: false,
  })),
  on(forceGrantSubmissionSuccess, (state) => ({
    ...state,
    forceGrantSubmissionLoading: false,
  })),

  on(generateDashboardData, (state) => ({
    ...state,
    generateDashboardDataLoading: true,
  })),
  on(generateDashboardDataFailure, (state, { error, message }) => ({
    ...state,
    generateDashboardDataError: { error, message },
    generateDashboardDataLoading: false,
  })),
  on(generateDashboardDataSuccess, (state) => ({
    ...state,
    generateDashboardDataLoading: false,
  })),

  on(getDashboards, (state) => ({
    ...state,
    dashboards: [],
    dashboardsLoading: true,
  })),
  on(getDashboardsFailure, (state, { error, message }) => ({
    ...state,
    dashboardsError: { error, message },
    dashboardsLoading: false,
  })),
  on(getDashboardsSuccess, (state, { response }) => ({
    ...state,
    dashboards: response.data,
    dashboardsLoading: false,
  })),

  on(getRemovedUserReport, (state) => ({
    ...state,
    removedUserReport: [],
    removedUserReportLoading: true,
  })),
  on(getRemovedUserReportFailure, (state, { error, message }) => ({
    ...state,
    removedUserReportError: { error, message },
    removedUserReportLoading: false,
  })),
  on(getRemovedUserReportSuccess, (state, { response }) => ({
    ...state,
    removedUserReport: response.data,
    removedUserReportLoading: false,
  })),

  on(getKeyDates, (state) => ({
    ...state,
    keyDates: [],
    keyDatesLoading: true,
  })),
  on(getKeyDatesFailure, (state, { error, message }) => ({
    ...state,
    keyDatesError: { error, message },
    keyDatesLoading: false,
  })),
  on(getKeyDatesSuccess, (state, { response }) => ({
    ...state,
    keyDates: response.data,
    keyDatesLoading: false,
  })),

  on(getOverviewReport, (state) => ({
    ...state,
    overviewReport: [],
    overviewReportLoading: true,
  })),
  on(getOverviewReportFailure, (state, { error, message }) => ({
    ...state,
    overviewReportError: { error, message },
    overviewReportLoading: false,
  })),
  on(getOverviewReportSuccess, (state, { response }) => ({
    ...state,
    overviewReport: response.data,
    overviewReportLoading: false,
  })),

  on(getReportingPeriods, (state) => ({
    ...state,
    reportingPeriods: [],
    reportingPeriodsLoading: true,
  })),
  on(getReportingPeriodsFailure, (state, { error, message }) => ({
    ...state,
    reportingPeriodsError: { error, message },
    reportingPeriodsLoading: false,
  })),
  on(getReportingPeriodsSuccess, (state, { response }) => ({
    ...state,
    reportingPeriods: response.data,
    reportingPeriodsLoading: false,
  })),

  on(updateDashboard, (state) => ({
    ...state,
    updateDashboardLoading: true,
  })),
  on(updateDashboardFailure, (state, { error, message }) => ({
    ...state,
    updateDashboardError: { error, message },
    updateDashboardLoading: false,
  })),
  on(updateDashboardSuccess, (state) => ({
    ...state,
    updateDashboardLoading: false,
  })),

  on(updateKeyDate, (state) => ({
    ...state,
    updateKeyDateLoading: true,
  })),
  on(updateKeyDateFailure, (state, { error, message }) => ({
    ...state,
    updateKeyDateError: { error, message },
    updateKeyDateLoading: false,
  })),
  on(updateKeyDateSuccess, (state) => ({
    ...state,
    updateKeyDateLoading: false,
  })),

  on(updateReportingPeriod, (state) => ({
    ...state,
    updateReportingPeriodLoading: true,
  })),
  on(updateReportingPeriodFailure, (state, { error, message }) => ({
    ...state,
    updateReportingPeriodError: { error, message },
    updateReportingPeriodLoading: false,
  })),
  on(updateReportingPeriodSuccess, (state) => ({
    ...state,
    updateReportingPeriodLoading: false,
  })),
);

export const reducer = (state: State | undefined, action: Action) =>
  settingsReducer(state, action);
